import { showSuccess, showError, hideFlash } from 'utils/messages';
import EasyPostConstants from 'app/easypost_constants';

import CreditCard from 'app/models/credit_card';

import Base from 'app/views/base';
import CreditCardErrorModal from 'app/views/modals/credit_card_error_modal';
import LoaderModal from 'app/views/modals/loader_modal';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .add_card': 'showStripe',
  },

  initialize({ priority, user }) {
    this.priority = priority;
    this.errorModal = new CreditCardErrorModal({});
    this.user = user;
    this.loaderModal = new LoaderModal();
  },

  context() {
    return {
      has_payment_method: !this.model.isNew(),
    };
  },

  showStripe(e) {
    e.preventDefault();
    const self = this;

    if (!window.StripeCheckout) {
      showError('Credit card payment gateway failed to load. Try reloading this page.');
      throw new Error('Stripe failed to load: window.StripeCheckout not present');
    }

    window.StripeCheckout.open({
      key: EasyPostConstants.StripePublicKey,
      name: EasyPostConstants.EasyPostName,
      image: EasyPostConstants.EasyPostIcon,
      description: 'Add a Credit Card to your Account',
      email: self.user.get('email'),
      panelLabel: 'Add Card',
      zipCode: true,
      allowRememberMe: false,
      address: true,
      token(response) {
        self.loaderModal.show();
        new CreditCard({}).save({
          stripe_object_id: response.id,
          priority: self.priority,
        }, {
          success(model) {
            hideFlash();
            self.model.set(`${self.priority}_payment_method`, model);
            showSuccess('Credit card successfully added to your account');
            self.loaderModal.close();
            self.model.trigger('newPaymentMethod');
          },
          error(model, res) {
            const responseBody = res.responseJSON;
            hideFlash();
            self.loaderModal.close();
            self.errorModal.message = responseBody.error.message;
            self.errorModal.show();
          },
        });
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/payment_methods/credit_card_button/index.js